import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { useCart } from '../../contexts/CartContext';

const CartButton = ({ className = '' }) => {
  const { totalItems, setCartOpen } = useCart();

  const handleClick = () => {
    setCartOpen(true);
  };

  return (
    <Button 
      variant="ghost" 
      size="icon" 
      className={`relative text-gray-700 hover:bg-gray-100 ${className}`}
      onClick={handleClick}
    >
      <ShoppingCart className="h-6 w-6" />
      {totalItems > 0 && (
        <Badge 
          className="absolute -top-2 -right-2 h-5 w-5 p-0 flex items-center justify-center text-xs bg-orange-500 hover:bg-orange-600"
        >
          {totalItems > 99 ? '99+' : totalItems}
        </Badge>
      )}
    </Button>
  );
};

export default CartButton;